
    export var PACKAGE_VERSION = '3.0.0 (8f12e74)';
    export var THEME = 'polaris';
    export var ALWAYS_VISUAL_REFRESH = false;
    